<div [ngClass]="_containerClass">
  <button
    (click)="onClick.emit()"
    [disabled]="isDisabled"
    [ngClass]="_buttonClasses"
    mat-button
  >
    {{ _i18nKey | translate }}
  </button>
</div>
